module.exports = __webpack_public_path__ + "img/logo-dev.7a7e5fb6.png";